import { styled } from "@linaria/react";
import { SIZE_M, SIZE_S } from "../../../constants";
import Card from "./card";
const CardContainer = /*#__PURE__*/styled("div")({
  name: "CardContainer",
  class: "cf38gc2"
});

function Cards(): JSX.Element {
  return <CardContainer>
      <Card index={0} />
      <Card index={1} />
      <Card index={2} />
    </CardContainer>;
}

export default Cards;

require("../../../../.linaria-cache/src/components/homepage/cards/index.linaria.module.css");